document.addEventListener('DOMContentLoaded', () => {
    const acordeones = document.querySelectorAll('.js-collection-acordeon_footer');

    acordeones.forEach((acordeon) => {
        acordeon.addEventListener('toggle', () => {
        const verticalLine = acordeon.querySelector('.line-vertical_footer');
        if (verticalLine) {
            if (acordeon.open) {
            verticalLine.classList.add('is-open');
            } else {
            verticalLine.classList.remove('is-open');
            }
        }
        });
    });
});